module.exports = __webpack_public_path__ + "static/media/ic_mobile.cf176eae.svg";